/**
 * tel-tracking.js — 電話番号タップの計測 (GA4)
 *
 * 目的: 「顧客はどの表示を見て電話をかけているか」を面ごとに数える。
 *       2026-08-27 時点では tel: リンクのタップ記録が 1 件も無く、面別の順位は
 *       「番号が目に入った回数 (= ページビュー)」で代用するしかなかった。
 *       最終目的は自己解決率の向上なので、減らしてよい面と残す面を分けるための一次データ。
 *
 * 送信イベント (GA4):
 *   tel_click  params: tel_source / tel_label
 *
 *   tel_source … 番号が置かれている面
 *                 footer      全ページ下部のフッター
 *                 faq_widget  右下に浮いている相談ボタン (Chatty / Avada FAQs)
 *                 faq_page    よくあるご質問ページ本文
 *                 header      ヘッダー
 *                 product     商品ページ本文 (大口注文の相談導線など)
 *                 page        その他の固定ページ本文 (LP・会社案内・特商法など)
 *                 other       上記に当てはまらない面
 *   tel_label  … リンクの文言 (先頭 100 字)。同じ面に複数の導線がある時の識別用
 *
 * 限界 (report する時は必ず添えること):
 *   ・パソコンで番号を目で見て手で押した発信は原理的に記録できない
 *   ・Google 検索 / マップの通話ボタンはサイト外なのでここには入らない
 *     (Google ビジネスプロフィール側の通話統計を見る)
 *
 * 配線: layout/theme.liquid の </body> 直前 (faq-tracking.js の隣)。
 *       ウィジェットは全ページ表示なので、特定テンプレートに限定しない。
 *
 * 実装方針: faq-tracking.js を踏襲。gtag + dataLayer 両系へ送信、未定義環境は no-op、
 *           例外は握りつぶす。**リンクの既定動作 (発信) には一切触らない**
 *           (preventDefault しない。計測のために発信を壊さない)。
 */
(function () {
  'use strict';

  var MAX_PARAM_LEN = 100; // GA4 のイベントパラメータ値の上限
  var WIDGET_ROOT = '.Avada-Faqs_Popup';

  function clean(value) {
    if (!value) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, MAX_PARAM_LEN);
  }

  function track(eventName, params) {
    try {
      var payload = Object.assign({ tool: 'tel' }, params || {});
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
    } catch (e) { /* swallow */ }
  }

  /**
   * リンクが置かれている面を判定する。
   * DOM の位置を先に見て、当てはまらない時だけ URL で分ける。
   * (フッターとウィジェットは全ページに出るので、URL より DOM が正しい)
   */
  function sourceOf(link) {
    try {
      if (link.closest(WIDGET_ROOT) || link.closest('#Avada-FAQ_WidgetTrigger')) {
        return 'faq_widget';
      }
      // フッターはテーマのセクショングループ。id は sections--<数字>__footer になる。
      if (link.closest('footer') || link.closest('[id*="__footer"]')) return 'footer';
      if (link.closest('header') || link.closest('[id*="__header"]')) return 'header';
      if (link.closest('[id*="__faq"]')) return 'faq_page';

      var path = (window.location && window.location.pathname) || '';
      if (path.indexOf('/products/') !== -1) return 'product';
      if (path.indexOf('/pages/faq') !== -1) return 'faq_page';
      if (path.indexOf('/pages/') !== -1) return 'page';
      return 'other';
    } catch (e) {
      return 'other';
    }
  }

  // click は capture で拾う。tel: は遷移が即座に起きる面があるため、
  // バブリング待ちにすると送信前にページを離れることがある。
  document.addEventListener('click', function (event) {
    try {
      var target = event.target;
      if (!target || !target.closest) return;
      var link = target.closest('a[href^="tel:"]');
      if (!link) return;

      track('tel_click', {
        tel_source: sourceOf(link),
        tel_label: clean(link.textContent)
      });
    } catch (e) { /* swallow */ }
  }, true);
})();
